function DashboardCard({ title, backgroundClass, onClick }) {
  const lines = title.split('\n');

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex min-h-[108px] w-full items-center justify-center rounded-[12px] px-4 py-5 text-center shadow-[0_3px_8px_rgba(15,23,42,0.18)] transition hover:-translate-y-0.5 hover:shadow-[0_8px_18px_rgba(15,23,42,0.18)] sm:min-h-[132px] lg:min-h-[180px] ${backgroundClass}`}
    >
      <span className="font-login text-[15px] font-bold leading-[1.35] text-white sm:text-[16px] lg:text-[20px]">
        {lines.map((line) => (
          <span key={line} className="block">
            {line}
          </span>
        ))}
      </span>
    </button>
  );
}

export default DashboardCard;
